export default __webpack_public_path__ + "static/media/warning.c43cb7ec.svg";